import React, { Fragment, useEffect, useState } from "react";
//Redux
//Material Ui
import TextField from "@material-ui/core/TextField";
import CardActions from "@material-ui/core/CardActions";
import Button from "@material-ui/core/Button";
import Card from "@material-ui/core/Card";
//Other
import { savelendConnector } from "../../../services/savelendWithdrawals/connector";
import TableNew, { CELL_TYPES } from "../../../shared/Table";
import "./WithdrawMoneyStyle.scss";
import SpecialAccountBalance from "./Savelend.SpecialAccount.Balance";
import MenuItem from "@material-ui/core/MenuItem";

const SavelendMoneyTransactions = ({
  savelendSpecialAccountOrders,
  savelendPostSpecialAccountWithdrawalOrder,
  savelendPostSpecialAccountDepositOrder,
  savelendPostConfirmSpecialAccountOrder,
  savelendPostCancelSpecialAccountOrder,
  savelendReceiveSpecialAccountOrders,
}) => {
  const [Transactions, UpdateTransactions] = useState({
    Amount: "",
    Currency: "",
    Notes: "",
  });
  const AccountEnum = ["SavelendFees", "TrustlyRecon", "SwishRecon"];
  const CurrencyEnum = ["SEK", "EUR"];

  const columns = [
    { key: "Id", label: "Id", visible: true, type: CELL_TYPES.text },
    {
      key: "SpecialAccount",
      label: "Account",
      visible: true,
      type: CELL_TYPES.text,
    },
    { key: "Amount", label: "Amount", visible: true, type: CELL_TYPES.number },
    {
      key: "Currency",
      label: "Currency",
      visible: true,
      type: CELL_TYPES.text,
    },
    {
      key: "Type",
      label: "Withdraw/Deposit",
      visible: true,
      type: CELL_TYPES.text,
    },
    { key: "Notes", label: "Notes", visible: true, type: CELL_TYPES.text },
    { key: "Created", label: "Created", visible: true, type: CELL_TYPES.date },
    {
      key: "Executed",
      label: "Executed",
      visible: true,
      type: CELL_TYPES.number,
    },
    {
      key: "actions",
      label: "Actions",
      visible: true,
      renderer: (value, item) => {
        return (
          <Fragment>
            <Button
              variant="contained"
              color="primary"
              onClick={() => savelendPostConfirmSpecialAccountOrder(item.Id)}
              disabled={item.Executed}
            >
              {item.Executed ? "Confirmed" : "Confirm"}
            </Button>
            {!item.Executed && (
              <Button
                variant="contained"
                color="secondary"
                onClick={() => savelendPostCancelSpecialAccountOrder(item.Id)}
              >
                Cancel
              </Button>
            )}
          </Fragment>
        );
      },
    },
  ];

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => savelendReceiveSpecialAccountOrders(), []);

  return (
    <React.Fragment>
      <Card className="card-style">
        <CardActions>
          <div className="row">
            <div className="col-md-12">
              <SpecialAccountBalance />
            </div>
          </div>
        </CardActions>
      </Card>

      <Card>
        <CardActions className="card-actions2">
          <span className="span-style">Register deposit / withdrawal:</span>
        </CardActions>
        <CardActions className="card-actions2">
          <TextField
            size="small"
            variant="outlined"
            select
            id="AssetClass"
            label="Account"
            value={Transactions.Account}
            onChange={(event) => {
              UpdateTransactions({
                ...Transactions,
                Account: event.target.value,
              });
            }}
          >
            {AccountEnum.map((a) => {
              return (
                <MenuItem value={a} key={a}>
                  {a}
                </MenuItem>
              );
            })}
          </TextField>
        </CardActions>
        <CardActions className="card-actions2">
          <TextField
            size="small"
            variant="outlined"
            select
            id="AssetClass"
            label="Currency"
            value={Transactions.Currency}
            onChange={(event) => {
              UpdateTransactions({
                ...Transactions,
                Currency: event.target.value,
              });
            }}
          >
            {CurrencyEnum.map((a) => {
              return (
                <MenuItem value={a} key={a}>
                  {a}
                </MenuItem>
              );
            })}
          </TextField>
        </CardActions>
        <CardActions className="card-actions2">
          <TextField
            type="number"
            size="small"
            value={Transactions.Amount}
            onChange={(event) => {
              UpdateTransactions({
                ...Transactions,
                Amount: event.target.value,
              });
            }}
            variant="outlined"
            label="Amount"
          />
        </CardActions>
        <CardActions className="card-actions2">
          <TextField
            style={{ marginLeft: "0px" }}
            onChange={(event) => {
              UpdateTransactions({
                ...Transactions,
                Notes: event.target.value,
              });
            }}
            value={Transactions.Notes}
            size="small"
            variant="outlined"
            label="Notes"
          />
        </CardActions>
        <CardActions>
          <Button
            style={{ margin: "0px" }}
            onClick={() => {
              savelendPostSpecialAccountWithdrawalOrder(
                Transactions.Account,
                Transactions.Currency,
                Transactions.Amount,
                Transactions.Notes,
              );
            }}
            fullWidth
            variant="contained"
            color="primary"
          >
            Withdraw
          </Button>
          <Button
            style={{ margin: "0px" }}
            onClick={() => {
              savelendPostSpecialAccountDepositOrder(
                Transactions.Account,
                Transactions.Currency,
                Transactions.Amount,
                Transactions.Notes,
              );
            }}
            fullWidth
            variant="contained"
            color="primary"
          >
            Deposit
          </Button>
        </CardActions>
      </Card>

      <TableNew
        columns={columns}
        items={savelendSpecialAccountOrders}
        tableKey={"savelendTransactionOrders"}
        actionColumnWidth={240}
      />
    </React.Fragment>
  );
};

export default savelendConnector(SavelendMoneyTransactions);
